export default __webpack_public_path__ + "static/media/pickup_done.0881139b.svg";